// import { app } from '../../utils/store';
// const Isotope = require('isotope-layout');

export default class Filters {
    constructor() {
        this.filter = {
            all: document.querySelectorAll('#filters a[data-filter-single]'),
            main: document.getElementById('filters'),
            btn_references: document.getElementById('btn-filter-references'),
            container_references: document.getElementById('filter-container-references'),
            statusbar: document.getElementById('filter-statusbar'),
            all_statusbar: document.querySelectorAll('#filter-statusbar a[data-filter-single]'),
        };
        this.results_references= document.querySelector('#results-references');
        this.body = document.querySelector('body');
        app.overlay = document.querySelector('.app-overlay');

        this.filter_blog = {
            btn: document.querySelectorAll('[data-term]'),
            element: document.querySelectorAll('[data-filter]'),
        }

    }

    init() {

        if (this.results_references) {
            this.toggle();
            this.filter_references();
            
        }

        if (this.filter_blog.btn) {
            this.filterBlog();
        }

    }

    toggle = () =>{
        this.filter.btn_references.addEventListener('click', (e) => {
            e.preventDefault();
            this.filter.container_references.classList.toggle('active-references');
            app.overlay.classList.toggle('active');
            this.body.classList.toggle('overflow-hidden');
        });
    }

    filterBlog = () => {
        this.filter_blog.btn.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                this.filter_blog.btn.forEach(btn => {
                    btn.classList.remove('active');
                });
                event.target.classList.add('active');
                var data_term = event.target.getAttribute('data-term');
                if (data_term == 'all'){
                    this.filter_blog.element.forEach(element => {
                        element.classList.remove('d-none');
                    });
                }else {
                    this.filter_blog.element.forEach(element => {
                        element.classList.add('d-none');
                        var data_filter = element.getAttribute('data-filter');
                        if (data_term == data_filter) {
                            element.classList.remove('d-none');
                        }
                    });
                }
            })
            
        });
    }

    filter_references = () => {
        // ForEach Filter Button
        var filter_result = [];
        var arrayLogo = [];
        this.filter.all.forEach((filter)=>{
            // On click
            filter.addEventListener( 'click', ( event ) => {
                var clickedFilter = event.target.getAttribute('data-filter-single');
                var logosFilter = document.querySelectorAll('#results-references div[data-filters-result]');
                // Clean the Array
                filter_result = [];
                arrayLogo = []
                // Set Class 'active';    
                event.target.classList.toggle('active');
                // Get all '.active'
                var selected = document.querySelectorAll('#filters a[data-filter-single].active');
                selected.forEach((choice) => {
                    var filterValue = choice.getAttribute('data-filter-single'); // Get the clicked value ([data-filter-single])
                    // Compile the Array
                    filter_result.push(filterValue);
                })
                filter_result.forEach((el) => {
                    var logos = document.querySelectorAll('#results-references [data-filters-result="'+el+'"]');

                    logos.forEach((el) => {
                        // Compile the Array
                        arrayLogo.push(el);
                    })
                })
                if (arrayLogo.length > 0) {
                    logosFilter.forEach((el) => {
                        el.classList.add('d-none');
                    })
                    arrayLogo.forEach((el) => {
                        el.classList.remove('d-none');
                    })
                } else {
                    logosFilter.forEach((el) => {
                        el.classList.remove('d-none');
                    })
                }
                // Hide Filter Statusbar
                if(event.target.classList.contains('active')){
                    document.querySelector('#filters .container a[data-filter-single="'+clickedFilter+'"]').classList.remove('d-none');
                } else {
                    document.querySelector('#filters .container a[data-filter-single="'+clickedFilter+'"]').classList.add('d-none');
                }
            });

        })

        this.filter.all_statusbar.forEach((filter)=>{
            // On click
            filter.addEventListener( 'click', ( event ) => {
                var clickedFilter = event.target.getAttribute('data-filter-single');
                var logosFilter = document.querySelectorAll('#results-references div[data-filters-result]');
                // Hide Filter Statusbar
                document.querySelector('#filters .container a[data-filter-single="'+clickedFilter+'"]').classList.add('d-none');
                document.querySelector('#filters #filter-container-references a[data-filter-single="'+clickedFilter+'"]').classList.remove('active');
                // Clean the Array
                filter_result = [];
                arrayLogo = []      
                // // Get all '.active'
                var selected = document.querySelectorAll('#filters #filter-container-references a[data-filter-single].active');
                selected.forEach((choice) => {
                    var filterValue = choice.getAttribute('data-filter-single'); // Get the clicked value ([data-filter-single])
                    // Compile the Array
                    filter_result.push(filterValue);
                })
                filter_result.forEach((el) => {
                    var logos = document.querySelectorAll('#results-references [data-filters-result="'+el+'"]');
                    logos.forEach((el) => {
                        // Compile the Array
                        arrayLogo.push(el);
                    })
                })
                if (arrayLogo.length > 0) {
                    logosFilter.forEach((el) => {
                        el.classList.add('d-none');
                    })
                    arrayLogo.forEach((el) => {
                        el.classList.remove('d-none');
                    })
                } else {
                    logosFilter.forEach((el) => {
                        el.classList.remove('d-none');
                    })
                }
            });
        })
    }
}
